import { Button, TextFieldProps } from "@shopify/polaris"
import classNames from "classnames"
import { HideIcon, ProTextField, ViewIcon } from "polaris-enhance"
import { useState } from "react"

import { isShopifyEmbedded } from "@/utils/app-bridge"

import { RuleItem } from "../../../utils"
import Styles from "./index.module.scss"

export type ProTextFieldWithPasswordProps = Omit<
  TextFieldProps,
  "autoComplete"
> & {
  active?: boolean
  rules?: RuleItem[]
}

export const ProTextFieldWithPassword = (
  props: ProTextFieldWithPasswordProps,
) => {
  const { active = false, value = "", onChange, rules, ...restProps } = props
  const [show, setShow] = useState(active)

  return (
    <div className={classNames("relative", Styles.TextFieldWithPassword)}>
      <ProTextField
        {...restProps}
        suffix={
          <div className="h-5">
            <Button
              variant="plain"
              icon={show ? ViewIcon : HideIcon}
              onClick={() => setShow(!show)}
            />
          </div>
        }
        rules={rules}
        value={value}
        onChange={onChange}
        type={show ? "text" : "password"}
      />
    </div>
  )
}
